import BroadcastPostSerializer from "@/issara-sdk/types/BroadcastPostSerializer_apps_PRX";
import React from "react";
import { Icon, Label } from "semantic-ui-react";

const ICON = {
  warning: "/static/images/meform/warning.png",
};

type BroadcastApprovalTorBarProps = {
  // config
  isApprovalPage?: boolean;
  // func & callback
  onOpenLog?: (broadcastPostId?: number) => void;
  // data
  broadcast?: BroadcastPostSerializer | null;
};

const BroadcastApprovalTopBar = (props: BroadcastApprovalTorBarProps) => {
  const broadcast = props.broadcast;

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div
        style={{
          color: "#656565",
          backgroundColor: "#ffe5e5",
          borderRadius: "4px",
          marginLeft: "10px",
          marginRight: "10px",
          fontStyle: "italic",
          padding: "7px",
        }}
      >
        {broadcast?.broadcast_id}: {broadcast?.status_custom_label}
      </div>

      {props.isApprovalPage && (
        <Icon
          name="history"
          style={{
            backgroundColor: "#d9d9d9",
            borderRadius: "4px",
            padding: "4px",
            width: "30px",
            height: "30px",
            textAlign: "center",
            cursor: "pointer",
            marginRight: "10px"
          }}
          onClick={() => props.onOpenLog?.(broadcast?.id)}
        />
      )}

      {/* --- REVIEWED (APPROVED) STATUS --- */}
      {broadcast?.status === "REVIEWED" && (
        <Label
          style={{
            backgroundColor: "#cbf0bd",
            borderRadius: "4px",
            padding: "7px"
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <Icon name="check" style={{ color: "#137e45" }} />
            <p style={{ marginLeft: "5px" }}>Approved</p>
          </div>
        </Label>
      )}

      {/* --- REJECTED STATUS --- */}
      {broadcast?.status === "REVIEW_REJECTED" && (
        <Label
          style={{
            backgroundColor: "white",
            borderRadius: "4px",
            padding: "7px"
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <img src={ICON.warning} alt="warning" style={{ width: "20px", height: "20px" }} />
            <p style={{ marginLeft: "5px", color: "var(--primary-theme-color)" }}>{broadcast.remark || ""}</p>
          </div>
        </Label>
      )}
    </div>
  );
};

export default BroadcastApprovalTopBar;
